export type JsonSuccess = {
  ok: true
  schema_version: 1
  environment: string
  data: unknown
  files: string[]
  warnings: string[]
}

export type JsonError = {
  ok: false
  schema_version: 1
  environment: string
  error: { code: string; message: string; hint?: string }
}

export function jsonSuccess(data: unknown, options: { environment: string; files?: string[]; warnings?: string[] }): string {
  const payload: JsonSuccess = {
    ok: true,
    schema_version: 1,
    environment: options.environment,
    data,
    files: options.files ?? [],
    warnings: options.warnings ?? [],
  }
  return JSON.stringify(payload)
}

export function jsonError(error: JsonError['error'], environment: string): string {
  return JSON.stringify({ ok: false, schema_version: 1, environment, error } satisfies JsonError)
}
